function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (obj) { return typeof obj; }; } else { _typeof = function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DateInput from './date/dateInput.js';
import CalendarHeader from './calendar/calendarHeader.js';
import DateTable from './date/dateTable.js';
import CalendarFooter from './calendar/calendarFooter.js';
import { noop, isAllowedDate as _isAllowedDate, syncTime } from './utils';
var __vue_script__ = {
  name: 'Calendar',
  components: {
    DateInput: DateInput,
    CalendarHeader: CalendarHeader,
    DateTable: DateTable,
    CalendarFooter: CalendarFooter
  },
  props: {
    prefixCls: {
      type: String,
      default: undefined
    },
    locale: {
      type: Object,
      default: undefined
    },
    value: {
      type: Date,
      default: undefined
    },
    mode: {
      type: String,
      default: 'date',
      validator: function validator(v) {
        return ['time', 'date', 'month', 'year', 'decade'].indexOf(v) > -1;
      }
    },
    format: {
      type: String,
      default: undefined
    },
    visible: {
      type: Boolean,
      default: true
    },
    showDateInput: {
      type: Boolean,
      default: true
    },
    showWeekNumber: {
      type: Boolean,
      default: false
    },
    showToday: {
      type: Boolean,
      default: true
    },
    showOk: {
      type: Boolean,
      default: false
    },
    showTime: {
      type: [Boolean, Object],
      default: false
    },
    dateInputPlaceholder: {
      type: String,
      default: ''
    },
    disabledDate: {
      type: Function,
      default: noop
    },
    disabledTime: {
      type: Function,
      default: noop
    },
    hasTimePicker: {
      type: Boolean,
      default: false
    },
    controlMode: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selectedValue: this.value,
      // 内部值传递
      innerValue: this.value,
      innerMode: this.mode
    };
  },
  computed: {
    okDisabled: function okDisabled() {
      var selectedValue = this.selectedValue;
      return !this.isAllowedDate(selectedValue);
    },
    isTimePicker: function isTimePicker() {
      return this.innerMode === 'time';
    },
    dateFormat: function dateFormat() {
      var locale = this.locale,
          hasTimePicker = this.hasTimePicker;
      var format = this.format;

      if (!format) {
        if (hasTimePicker) {
          format = locale.dateTimeFormat;
        } else {
          format = locale.dateFormat;
        }
      }

      return format;
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          showWeekNumber = this.showWeekNumber,
          hasTimePicker = this.hasTimePicker;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-week-number"), showWeekNumber), _defineProperty(_ref, "".concat(prefixCls, "-time"), hasTimePicker), _ref;
    }
  },
  watch: {
    value: function value(nVal) {
      this.selectedValue = nVal || new Date();
      this.innerValue = nVal || new Date();
    },
    mode: function mode(nVal, oVal) {
      if (nVal !== oVal) {
        this.innerMode = nVal;
      }
    }
  },
  created: function created() {
    var innerValue = this.innerValue,
        showTime = this.showTime;

    if (!(innerValue instanceof Date)) {
      var date = new Date();

      if (_typeof(showTime) === 'object') {
        date = syncTime(date, showTime.defaultValue);
      }

      this.innerValue = date;
    }
  },
  methods: {
    isAllowedDate: function isAllowedDate(value) {
      var disabledDate = this.disabledDate,
          disabledTime = this.disabledTime;
      return _isAllowedDate(value, disabledDate, disabledTime);
    },
    onPanelChange: function onPanelChange(value, next) {
      var controlMode = this.controlMode,
          innerValue = this.innerValue;

      if (!controlMode) {
        this.innerMode = next;
      }

      this.$emit('on-panel-change', value || innerValue, next);
    },
    updateValue: function updateValue(value) {
      this.selectedValue = value;
      this.innerValue = value;
      this.$emit('on-select', value);
    },
    updateInnerValue: function updateInnerValue(value) {
      this.innerValue = value;
    },
    onOK: function onOK() {
      this.$emit('on-ok', this.selectedValue);
    },
    onTimePickerClick: function onTimePickerClick() {
      var isTimePicker = this.isTimePicker,
          onPanelChange = this.onPanelChange;

      if (isTimePicker) {
        onPanelChange(null, 'date');
      } else {
        onPanelChange(null, 'time');
      }
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    class: _vm.classes
  }, [_c('div', {
    class: _vm.prefixCls + "-panel",
    attrs: {
      "role": "panel"
    }
  }, [_vm.showDateInput ? _c('date-input', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "locale": _vm.locale,
      "format": _vm.dateFormat,
      "value": _vm.selectedValue,
      "placeholder": _vm.dateInputPlaceholder
    },
    on: {
      "on-change": _vm.updateValue
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.prefixCls + "-date-panel"
  }, [_c('calendar-header', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "format": _vm.dateFormat,
      "mode": _vm.innerMode,
      "value": _vm.innerValue,
      "locale": _vm.locale,
      "is-time-picker": _vm.isTimePicker
    },
    on: {
      "on-change": _vm.updateInnerValue,
      "on-panel-change": _vm.onPanelChange
    }
  }), _vm._v(" "), _vm.hasTimePicker && _vm.isTimePicker ? _c('div', [_c('div', {
    class: _vm.prefixCls + "-time-picker"
  }, [_c('div', {
    class: _vm.prefixCls + "-time-picker-panel"
  }, [_vm._t("timePicker", null, {
    "onChange": _vm.updateValue
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.prefixCls + "-body"
  }, [_c('date-table', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "value": _vm.innerValue,
      "selected-value": _vm.selectedValue,
      "format": _vm.dateFormat,
      "locale": _vm.locale,
      "disabled-date": _vm.disabledDate,
      "show-week-number": _vm.showWeekNumber
    },
    on: {
      "on-select": _vm.updateValue
    }
  })], 1), _vm._v(" "), _c('calendar-footer', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "locale": _vm.locale,
      "value": _vm.innerValue,
      "show-ok": _vm.showOk,
      "is-time-picker": _vm.isTimePicker,
      "has-time-picker": _vm.hasTimePicker,
      "show-today": _vm.showToday,
      "ok-disabled": _vm.okDisabled,
      "format": _vm.dateFormat,
      "disabled-date": _vm.disabledDate
    },
    on: {
      "on-ok": _vm.onOK,
      "on-today": _vm.updateValue,
      "on-time-picker": _vm.onTimePickerClick
    }
  })], 1)], 1)]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "calendar.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);